import React from 'react';
import styles from './index.module.scss';
import { parseISO, format } from "date-fns";
import { style } from '@mui/system';
import { Program } from '../../pages/Registration';
import { DataGrid } from '@mui/x-data-grid';
import { formatDate, formatIndianCurrency } from '../../utils/commonFunctions';
import { stringToNumber } from '../../utils/registrationUtils';
import location from '../../assets/images/Location.svg';
import inverstment from '../../assets/images/investmentMobile.svg';
import date from '../../assets/images/dateIcon-mobile.svg';
import { VIEW_DETAILS } from '../../constants';
import { highlightMahatriaAndInfinitheism } from '../../common/components/HighlightMahatriaInfinitheism';

interface ProgramInfoCardProps {
  subPrograms: Program[];
}
function formatCheckinTime(isoString: string) {
  if (!isoString) return "";
  const date = parseISO(isoString);
  return format(date, "hh:mm aaaa 'on' EEE, dd MMM yyyy").replace("AM", "a.m.").replace("PM", "p.m.");
}
function formatProgramDates(startsAt: string, endsAt: string) {
  if (!startsAt || !endsAt) return "";
  const start = parseISO(startsAt);
  const end = parseISO(endsAt);

  // Example: Wed, 18 Sep to Sat, 21 Sep 2024
  const startStr = formatDate(start.toString());
  const endStr = formatDate(end.toString());
  return `${startStr} to ${endStr}`;
}
const ProgramInfoTable: React.FC<ProgramInfoCardProps> = ({ subPrograms }) => {
  var gstPercentage = 0;
  if(subPrograms?.length >= 1) {
    gstPercentage = stringToNumber(subPrograms[0].cgst) + stringToNumber(subPrograms[0].sgst)
  }
  return (
    <div className={styles.tableContainer}>
      <div className={styles.tableHeader}>
        <div className={styles.programName}>{VIEW_DETAILS.PROGRAM_NAME}</div>
        <div className={styles.tableTitle}>{VIEW_DETAILS.PROGRAM_DATES}</div>
        {/* <div className={styles.tableTitle}>Venue</div> */}
        <div className={styles.tableTitle}>{VIEW_DETAILS.INVESTMENT}</div>
      </div>
      {subPrograms.map((gp: any, gpIdx: number) => (
        <>
          <div className={styles.tableRow} key={gpIdx}>
            <div className={styles.sessionName}>{highlightMahatriaAndInfinitheism(gp.name)}</div>
            <div className={styles.programDates}>
              <span className={styles.iconOnlyMobile}><img src={date} alt="" /></span>
              {formatProgramDates(gp.startsAt, gp.endsAt)}
            </div>
            {/* <div className={styles.programDates}>
              <span className={styles.iconOnlyMobile}><img src={location} alt="" /></span>
              {gp.venue}
            </div> */}
            <div className={styles.tableData}>
              <span className={styles.iconOnlyMobile}>
                <img src={inverstment} alt="" />Investment:{" "}
              </span>
              INR {formatIndianCurrency(Math.round(stringToNumber(gp.basePrice)))}{" "}/-
              {/* <br /> */}
            &nbsp; (plus GST {gstPercentage}%)
            </div>
          </div>
          {gpIdx != subPrograms.length - 1 && <div className={styles.seprationLine}></div>}
        </>

      ))
      }
      <div className={styles.seprationLine}></div>
      <div className={styles.venue}>
        <div><img src={location} alt="Location" /></div>
      <div>{subPrograms[0].venue}</div>
      </div>
    </div>
  );
}
export default ProgramInfoTable;